import { ComponentSize } from '../../../types';

// Maps the size of the Dot element to a size class.
export const DOT_SIZE: Record<ComponentSize, string> = {
  [ComponentSize.X_SMALL]: 'h-2 w-2',
  [ComponentSize.SMALL]: 'h-3 w-3',
  [ComponentSize.MEDIUM]: 'h-4 w-4',
  [ComponentSize.LARGE]: 'h-5 w-5',
};
